import React from 'react'
import PropTypes from 'prop-types'

import { Icon } from 'semantic-ui-react';

import { uTimestamp } from 'utils';
import moment from 'moment';

import './style.css';

class Timestamp extends React.Component {

  render() {

    const { icon, start, stop } = this.props;

    let duration = moment.duration(uTimestamp.diff(start, stop), 'seconds');

    var minutes = duration.minutes();
    duration.subtract(moment.duration(minutes, 'minutes'));

    var seconds = duration.seconds();
    duration.subtract(moment.duration(seconds, 'seconds'));

    var milliseconds = Math.floor(duration.milliseconds());

    return (
      <span className="timestamp">

        {icon &&
          <Icon name="stopwatch" />
        }

        {/* Duration */}
        <span className="duration">

          {/* Minutes */}
          <span className="minutes">
            {String(minutes).padStart(2, '0')}
          </span>

          :

          {/* Seconds */}
          <span className="seconds">
            {String(seconds).padStart(2, '0')}
          </span>

          {/* Milliseconds */}
          <span className="milliseconds">
            {`.${String(milliseconds).padStart(3, '0')}`}
          </span>
        </span>
      </span>
    );
  }
}

Timestamp.defaultProps = {
  icon: true
};

Timestamp.propTypes = {
  icon: PropTypes.bool.isRequired,
  start: PropTypes.number.isRequired,
  stop: PropTypes.number.isRequired
};

export default Timestamp;
